import React from 'react';

import styles from '../fundProfileShowPageStyles';

import AllocatorBlocklistModal from 'buyside/components/presentation/FundProfileShowPage/AllocatorBlocklistModal/allocatorBlocklistModal';
import FundProfileSection from './fundProfileSection';

import {
  ICONS,
  TITLES,
  TIPS,
  EMPTY_TEXT,
  COMPONENTS,
  EDIT_FORMS,
  EDIT_FORM_BOX_TEXT,
  REORDER_FORMS,
  REORDER_FORM_BOX_TEXT,
  VALIDATION_SCHEMATA
} from 'buyside/util/fundProfileConstants';

const sectionPropsFromConstants = section => {
  return {
    icon: ICONS[section],
    title: TITLES[section],
    tip: TIPS[section],
    emptyText: EMPTY_TEXT[section] || EMPTY_TEXT.default,
    component: COMPONENTS[section],
    editForm: EDIT_FORMS[section],
    editFormBoxText: EDIT_FORM_BOX_TEXT[section],
    reorderForm: REORDER_FORMS[section],
    reorderFormBoxText: REORDER_FORM_BOX_TEXT[section],
    validationSchema: VALIDATION_SCHEMATA[section]
  };
};

class FundProfileSections extends React.Component {
  constructor() {
    super();
    this.state = {
      openAllocatorBlocklistModal: false
    };
    this.openBlocklistModal = this.openBlocklistModal.bind(this);
  }

  openBlocklistModal() {
    this.setState({
      openAllocatorBlocklistModal: true
    });
  }

  render() {
    const { fundProfileId, sectionProps, showUserDetails, visibleSections } = this.props;

    return (
      <>
        <AllocatorBlocklistModal
          fundProfileId={fundProfileId}
          isOpen={this.state.openAllocatorBlocklistModal}
          onClose={() => this.setState({ openAllocatorBlocklistModal: false })}
        />
        {visibleSections.map((section, idx) => {
          return (
            <section key={idx} className={styles.profileSection} id={section} data-testid={section}>
              <FundProfileSection
                fundProfileId={fundProfileId}
                section={section}
                openBlocklistModal={this.openBlocklistModal}
                {...sectionPropsFromConstants(section)}
                {...sectionProps(section)}
                showUserDetails={showUserDetails}
              />
            </section>
          );
        })}
      </>
    );
  }
}

export default FundProfileSections;
